import { Box } from '@mui/material';
import React from 'react';
import PageTitle from '../components/PageTitle';
import ChangePassword from './components/ChangePassword/ChangePassword';
import HistoricalResultsAccess from './components/HistoricalResultsAccess/HistoricalResultsAccess';
import HistoricalResultsManagement from './components/HistoricalResultsManagement/HistoricalResultsManagement';
import PricelistAccess from './components/PricelistAccess/PricelistAccess';
import PricelistManagement from './components/PricelistManagement/PricelistManagement';
import './Profile.scss';

const Profile = () => {
  return (
    <>
      <PageTitle pageTitle="Profile" />
      <Box className="profile">
        <Box className="group">
          <ChangePassword />
        </Box>

        <Box className="group">
          <h2>Online Results</h2>
          <HistoricalResultsAccess />
          <HistoricalResultsManagement />
        </Box>

        <Box className="group">
          <h2>Pricelists</h2>
          <PricelistAccess />
          <PricelistManagement />
        </Box>
      </Box>
    </>
  );
};

export default Profile;
